import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { PagePreview } from '../components/page-editor/PagePreview'
import type { CanvasSlot } from '../components/editor-shared/canvasTypes'
import type { BlockContent } from '../api/types'

interface PreviewState {
  slots: CanvasSlot[]
  contentMap: Record<string, BlockContent>
  pageTitle: string
}

export default function LivePreviewPage() {
  const { id } = useParams<{ id: string }>()
  const [state, setState] = useState<PreviewState | null>(null)

  useEffect(() => {
    if (!id) return
    const channel = new BroadcastChannel(`wire-ui:preview:${id}`)

    channel.onmessage = (ev: MessageEvent) => {
      if (ev.data?.type === 'state') {
        setState({
          slots: ev.data.slots,
          contentMap: ev.data.contentMap,
          pageTitle: ev.data.pageTitle,
        })
      }
    }

    // Request an immediate state snapshot from the editor.
    channel.postMessage({ type: 'ready' })

    return () => channel.close()
  }, [id])

  if (!state) {
    return (
      <div className="flex h-screen items-center justify-center bg-canvas">
        <div className="flex flex-col items-center gap-4 text-center">
          <Loader2 size={24} className="animate-spin text-fg-secondary" />
          <p className="text-sm font-semibold text-fg">Waiting for editor…</p>
          <p className="max-w-xs text-xs text-fg-secondary">
            Keep the editor tab open. This window will update live as you make changes.
          </p>
        </div>
      </div>
    )
  }

  return (
    <PagePreview
      slots={state.slots}
      contentMap={state.contentMap}
      pageTitle={state.pageTitle}
      mode="popout"
    />
  )
}
